import AccountList from './components/AccountList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { loadAgencies } from '../../shared/redux/entities/actions';
import { loadKPIsForAgencies } from '../../shared/redux/kpis/actions';

import './assets/AccountList.css';

function mapStateToProps(state,props){
  const accounts = values(state.entities.agencies)
    .filter((a) => a.name && a.name.length > 0)
    .sort((a,b) => (a.name || '').localeCompare((b.name || '')))
    .map((a) => {
      a.totalBrands = get(state,['kpis','agencies',a.id,'totalBrands']);
      a.totalBudget = get(state,['kpis','agencies',a.id,'totalBudget']);
      return a;
    });

  return {
    accounts:accounts
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({loadAgencies,loadKPIsForAgencies},dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountList)); 


// WEBPACK FOOTER //
// ./src/routes/AccountList/index.js